module.exports = __webpack_public_path__ + "img/14.9a20b3fc.png";